import { render, staticRenderFns } from "./catCode-detail.vue?vue&type=template&id=ea688980"
import script from "./catCode-detail.vue?vue&type=script&lang=js"
export * from "./catCode-detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports